import { seatAvailabilityStatusValidator } from '@vista/omnichannel-components-domain';
import { SeatAvailabilityStatus } from '@vista-digital/ocapi-types/v1';
import { Validator } from '@vista-digital/validator';
import { seatAppearanceRuleValidator } from './seat-appearance-rule';
import { defaultSeatPickerSeatAppearancesConfig, seatPickerSeatAppearancesConfigValidator } from './seat-type-appearance';
export const defaultSeatPickerSeatsConfig = {
    appearance: defaultSeatPickerSeatAppearancesConfig,
    minimumSize: 44,
    margin: 0,
    appearanceRules: [],
    allowSeatsInUnallocatedAreasToBeSelected: false,
    defaultAvailabilityStatus: SeatAvailabilityStatus.Sold,
    legacyMode: false
};
export const seatPickerSeatsConfigValidator = Validator.object({
    appearance: seatPickerSeatAppearancesConfigValidator,
    minimumSize: Validator.number({ min: 0 }),
    margin: Validator.number({ min: 0 }),
    appearanceRules: Validator.array({ items: seatAppearanceRuleValidator }),
    allowSeatsInUnallocatedAreasToBeSelected: Validator.boolean(),
    defaultAvailabilityStatus: seatAvailabilityStatusValidator,
    legacyMode: Validator.boolean()
});
